import { Box, Typography } from "@mui/material";
import aboutFlowers from "../images/coffin.png";
import cameraLady from "../images/camera-lady.png";

const AboutSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fff",
        py: { xs: "48px", md: "72px" },
        px: { xs: "24px", md: "80px" },
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "896px",
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { md: "space-between" },
          alignItems: "flex-start",
          position: "relative",
          rowGap: { xs: "48px", md: 0 },
        }}
      >
        {/* Left column */}
        <Box
          sx={{
            width: { xs: "100%", md: "380px" },
            display: "flex",
            flexDirection: "column",
            gap: "56px",
            zIndex: 10,
          }}
        >
          {/* Text */}
          <Box sx={{ maxWidth: "384px" }}>
            <Typography
              sx={{
                fontFamily: "Mulish",
                fontSize: "28px",
                fontWeight: 700,
                color: "#111111",
                letterSpacing: "-0.025em",
                mb: "16px",
              }}
            >
              About
            </Typography>
            <Typography
              sx={{
                fontFamily: "Mulish",
                color: "#737373",
                fontSize: { xs: "15px", md: "17px" },
                fontWeight: 400,
                lineHeight: 1.7,
              }}
            >
              For over two decades, Muzukuru has been a trusted name in funeral
              services, providing compassionate care to families across
              Zimbabwe. We understand that every life is unique and deserves to
              be celebrated with dignity and respect.
            </Typography>
          </Box>

          {/* Flowers image with play button */}
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "340px",
              aspectRatio: "3 / 3.8",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 1px 3px rgba(0,0,0,0.10)",
            }}
          >
            <Box
              component="img"
              src={aboutFlowers}
              alt="Funeral floral arrangements"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
            {/* Play button */}
            <Box
              sx={{
                position: "absolute",
                bottom: "20px",
                right: "20px",
              }}
            >
              <Box
                sx={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  bgcolor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "scale(1.05)" },
                }}
              >
                <svg
                  width="14"
                  height="14"
                  fill="#CB8850"
                  viewBox="0 0 24 24"
                  style={{ marginLeft: "2px" }}
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Right column */}
        <Box
          sx={{
            width: { xs: "100%", md: "440px" },
            display: "flex",
            justifyContent: "flex-end",
            transform: { md: "translateY(-64px)" },
            zIndex: 10,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "410px",
              aspectRatio: "3.5 / 4",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 1px 3px rgba(0,0,0,0.10)",
            }}
          >
            <Box
              component="img"
              src={cameraLady}
              alt="Live streaming infrastructure"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutSection;
